import { render, staticRenderFns } from "./ele.vue?vue&type=template&id=066b112b&scoped=true"
import script from "./ele.vue?vue&type=script&lang=js"
export * from "./ele.vue?vue&type=script&lang=js"
import style0 from "./ele.vue?vue&type=style&index=0&id=066b112b&prod&lang=scss"
import style1 from "./ele.vue?vue&type=style&index=1&id=066b112b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066b112b",
  null
  
)

export default component.exports